import HipaaLogo from '@assets/hipaa-logo.svg?react';
import {
  DeleteForever,
  HealthAndSafety,
  Lock,
  Policy,
  Shield,
} from '@mui/icons-material';
import { Box, Card, CardContent, Typography } from '@mui/material';

const SECURITY_ITEMS = [
  {
    icon: Lock,
    title: 'Secure collection',
    description: 'Audio and clinical data encrypted in ISO-certified AWS infrastructure.',
  },
  {
    icon: Shield,
    title: 'Automatic redaction',
    description: 'PII removed before AI processing (SOC 2 compliant, optional but default).',
  },
  {
    icon: HealthAndSafety,
    title: 'Data minimization',
    description: 'Raw audio permanently deleted after transcription completes.',
  },
  {
    icon: Policy,
    title: 'Compliant workflows',
    description: 'Notes, billing, and e-prescribing processed via HIPAA, SOC 2, GDPR, CCPA compliant systems.',
  },
  {
    icon: DeleteForever,
    title: 'Secure deletion',
    description: 'Data stored securely until you delete it—then permanently removed.',
  },
];

export function SecurityOverviewSection() {
  return (
    <Card elevation={0} sx={{ borderRadius: 2, border: 1, borderColor: 'grey.200', mb: 3 }}>
      <CardContent sx={{ pb: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Security & privacy are built into every JotPsych plan
          </Typography>
          <HipaaLogo height={32} fill="#6B21A8" aria-label="HIPAA Compliant" />
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          JotPsych is built to meet the highest standards of security, privacy, and healthcare
          compliance across clinical documentation, billing, and e-prescribing.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
          All information (audio capture, notes, claims submission, prescriptions, etc.) is
          encrypted, minimized, and handled in accordance with HIPAA and international privacy
          regulations.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {SECURITY_ITEMS.map((item, index) => {
            const Icon = item.icon;
            return (
              <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <Icon
                  sx={{
                    fontSize: 20,
                    color: 'primary.main',
                    mt: 0.25,
                    flexShrink: 0,
                  }}
                />
                <Box>
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{ fontWeight: 600, mr: 0.75 }}
                  >
                    {item.title}
                  </Typography>
                  <Typography component="span" variant="body2" color="text.secondary">
                    {item.description}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );
}
